import MedicalSummaryButtonIcon from '../../assets/icons/Vector.svg?react'
import TooltipWrapper from './TooltipWrapper';
import { useAddCaseFormContext } from '../../contexts/AddCaseFormContext';
import RenderIf from '../render-if/Renderif';
import XButton from '../common/XButton';
import { useMedicalSummary } from '../../hooks/useMedicalSummary';
import useMedicalSummaryLoadingPercentage from '../../hooks/useMedicalSummaryLoadingPercentage';

// The white fill these used to force was only needed on the old Ocean panel; on
// Stone the outlinePrimary variant reads correctly on its own.
const generateBtnClasses = "disabled:opacity-100! pointer-events-auto";

const MedicalSummaryBtns = () => {
    const { generateMedicalSummary, isDisableSubmitButton, submitBtnToolTipMsg } = useAddCaseFormContext();
    const {isPreProcessRecordLoading} = useMedicalSummaryLoadingPercentage();
    const {
        isMedicalRecordsGeneratedPreviously,
        hasUserUploadedAnyMedicalRecords,
        handleDownload,
    } = useMedicalSummary();

    return (
        <>
            <TooltipWrapper
                showTooltip={submitBtnToolTipMsg}
                title={submitBtnToolTipMsg}
                variant="error"
            >
                <XButton
                    id="summaryBtn"
                    variant="outlinePrimary"
                    className={generateBtnClasses}
                    disabled={isPreProcessRecordLoading || isDisableSubmitButton || !hasUserUploadedAnyMedicalRecords}
                    onClick={() => generateMedicalSummary({ skipConfirm: isMedicalRecordsGeneratedPreviously })}
                >
                    <RenderIf shouldRender={isPreProcessRecordLoading}>
                        <div className="w-4 h-4 border-2 border-black/10 [border-left-color:var(--theme)] rounded-full animate-spin"></div>
                    </RenderIf>
                    <RenderIf shouldRender={!isPreProcessRecordLoading}>
                        <MedicalSummaryButtonIcon />
                    </RenderIf>
                    {isMedicalRecordsGeneratedPreviously ? "Regenerate" : "Generate Medical Summary"}
                </XButton>
            </TooltipWrapper>

            <RenderIf shouldRender={isMedicalRecordsGeneratedPreviously}>
                <XButton
                    variant="outlinePrimary"
                    onClick={handleDownload}
                >
                    Download
                </XButton>
            </RenderIf>
        </>
    )
}

export default MedicalSummaryBtns;
